<template>
  <a ref="js-fancybox"><slot /></a>
</template>

<script>
require('@fancyapps/fancybox');

export default {
  name: "fancy-box",
  mounted () {
    $(this.$refs["js-fancybox"]).fancybox({
      infobar: false,
      buttons: [
        //"zoom",
        //"share",
        //"slideShow",
        //"fullScreen",
        //"download",
        //"thumbs",
        "close"
      ]
    });
  },
}
</script>

<style lang="css">
@import '~@fancyapps/fancybox/dist/jquery.fancybox.css';
</style>